import { useNavigate } from "react-router-dom";
import {
  Flame, Fan, Zap, Wind, Gauge, Atom, Droplets,
} from "lucide-react";

const ICONS = { flame: Flame, fan: Fan, zap: Zap, wind: Wind, gauge: Gauge, atom: Atom, droplets: Droplets };

export function UtilitiesBar({ utilities }) {
  const navigate = useNavigate();
  if (!utilities) return null;
  return (
    <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }} data-testid="utilities-bar">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] uppercase tracking-widest text-[var(--oim-text-dim)] font-heading">Utilities & Offsites (shared across all 3 chains) — see Energy & Resource for detail</div>
        <span className="text-[9px] px-1.5 py-0.5 rounded-full border border-[var(--oim-border)] text-[var(--oim-text-dim)]" data-testid="utilities-aggregate-badge" title="Computed from plant-wide utility ratios, not individual equipment twins">AGGREGATE MODEL</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
        {utilities.map((u) => {
          const Icon = ICONS[u.icon] || Zap;
          return (
            <button
              key={u.key}
              onClick={() => navigate("/energy")}
              data-testid={`utility-${u.key}`}
              className="group flex flex-col items-center gap-1 text-center rounded-lg py-2 transition-colors hover:bg-[var(--oim-hover)] cursor-pointer"
            >
              <Icon className="w-5 h-5 group-hover:opacity-100" style={{ color: "var(--oim-text-secondary)" }} strokeWidth={1.5} />
              <span className="text-[10px] font-heading font-semibold text-[var(--oim-text)]">{u.name}</span>
              <span className="text-[9px] text-[var(--oim-text-dim)]">{u.source}</span>
              <span className="font-mono-data text-xs text-[var(--oim-text-secondary)]">{u.value} {u.unit}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
